import { compose, withHandlers } from 'recompose';
import { withDataLayerPush } from './withDataLayerPush';

// This push dataLayer by method

export const withDataLayerCustomerTypePush = compose(
  withDataLayerPush,
  withHandlers({
    dataLayerCustomerTypePush: ({ dataLayerPush }) => ({
      customerType,
    }) => {
      dataLayerPush({
        event: 'customerType',
        customerType,
      });
    },
  }),
);



// WEBPACK FOOTER //
// ./src/Common/GTM/WithDataLayerCustomerType.js